<app-header></app-header>
<div class="responsive">
    <div class="container-fluid">



        <div class="row">
            <div class="col-md-3">
                <app-sidebar></app-sidebar>
            </div>
            <div class="col-md-6">
                <div class="card">
                    <div class="image-wrapper">
                        <img class="card-img-top" src="assets/church_image.jpg" alt="Card image cap">
                    </div>
                    <div class="card-body">
                        <div class="margin-b">
                            <h5 class="card-title">Get paid by Ministry</h5>
                            <p class="card-text">Ministry partner with Strip for fast, secure payments fill out a few
                                details so you can start getting paid.</p>
                        </div>
                        <div class="margin-b">
                            <div class="form-group">
                                <div class="row">
                                    <div class="col-md-6">
                                        <label>Country</label>
                                        <select class="form-control input-small">
                                            <option>Select Country</option>
                                        </select>


                                    </div>
                                </div>
                                <small id="passwordHelpBlock" class="form-text text-muted">
                                    Please select the country where you or you business will legally operate.
                                </small>

                            </div>
                        </div>


                        <div class="radio margin-b">
                            <div class="form-group">
                                <label>Type of entity</label>
                                <div class="form-check">
                                    <label class="form-check-label">
                                        <input type="radio" class="form-check-input" name="optradio">Individual, sole
                                        propreitor, or single-member LLC
                                    </label>
                                </div>
                                <div class="form-check">
                                    <label class="form-check-label">
                                        <input type="radio" class="form-check-input" name="optradio">Company
                                    </label>
                                </div>
                                <div class="form-check disabled">
                                    <label class="form-check-label">
                                        <input type="radio" class="form-check-input" name="optradio">Non-profit
                                        Organization
                                    </label>
                                </div>
                            </div>
                        </div>
                        <!-- Mobile -->
                        <div class="margin-b">
                            <div class="form-group">
                                <div class="row">
                                    <label>Mobile</label>
                                    <div class="col-md-2">
                                        <select class="form-control input-small">
                                            <option>Select Country</option>
                                        </select>
                                    </div>

                                    <div class="col-md-6">
                                        <input type="number" class="form-control" placeholder="Enter Mobile Number">
                                    </div>



                                </div>
                            </div>
                            <small id="passwordHelpBlock" class="form-text text-muted">
                                We'll text this number to verify your account.
                            </small>

                        </div>

                        <div class="margin-b">
                            <div class="form-group">
                                <div class="row">
                                    <div class="col-md-6">
                                        <label>Email</label>
                                       <input type="email" class="form-control" placeholder="Enter your email">

                                    </div>
                                </div>
                            

                            </div>
                        </div>


                    </div>




                </div>
            </div>
        <div class="col-md-3">
            <app-events [showheader]=true ></app-events>

        </div>
    </div>

</div>
</div>



<!-- <p class="card-text">Please select the country  where you or you business will legally operate.  </p> -->